import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@copro/api';
import type { AiChatMessage, AiChatSource } from '../types/aiChat.types';
import { keys } from './keys';

async function fetchAiConversationMessages(conversationId: string): Promise<AiChatMessage[]> {
  const { data, error } = await apiClient
    .from('ai_messages')
    .select('id, role, text, sources')
    .eq('conversation_id', conversationId)
    .order('created_at', { ascending: true });

  if (error) {
    throw error;
  }

  return (data ?? []).map((row) => ({
    id: row.id,
    role: row.role === 'user' ? 'user' : 'assistant',
    text: row.text,
    sources: Array.isArray(row.sources) ? (row.sources as unknown as AiChatSource[]) : [],
  }));
}

export function useGetAiConversationMessages(conversationId: string | undefined) {
  return useQuery({
    queryKey: keys.messages(conversationId ?? ''),
    queryFn: () => fetchAiConversationMessages(conversationId!),
    enabled: !!conversationId,
  });
}
